import Color from 'color'
import i18next from 'i18next'
import { BrandingGuide, BrandingManifest } from '~/ui/styling'
import { BeWizrModel } from './BeWizrModel'

export class BeWizrProfile extends BeWizrModel {

  hasDashboardAccess:       boolean = false
  hasNonParticipantCourses: boolean = false

  organization!:           BeWizrOrganization
  branding!:               BeWizrBrandingGuide | null
  availableOrganizations!: BeWizrOrganization[] | null

  protected afterDeserialize() {
    if (this.raw.branding == null) { return }
    this.branding = BeWizrBrandingGuide.deserialize(this.raw.branding)
  }
}

export interface BeWizrOrganization {
  id:       string
  title:    string
}

export class BeWizrBrandingGuide extends BeWizrModel {
  logo!:           string | null
  favicon!:        string | null
  primaryColor!:   string | null
  secondaryColor!: string | null

  public convertToBrandingGuide(title?: string): BrandingGuide {
    const colors: BrandingManifest['colors'] = {}
    const white = new Color('#fff')
    if (this.primaryColor != null) {
      colors['primary']       = this.primaryColor
      colors['fg-dark-link']  = this.primaryColor
      colors['fg-light-link'] = new Color(this.primaryColor).mix(white, 0.9).hex()
    }
    if (this.secondaryColor != null) {
      colors.secondary = this.secondaryColor
      colors['fg-dark-highlight']  = this.secondaryColor
      colors['fg-light-highlight'] = new Color(this.secondaryColor).mix(white, 0.9).hex()
    }

    const images: BrandingManifest['images'] = {}
    if (this.logo != null) {
      images.logo = {
        type: 'remote',
        url:  this.logo,
      }
    }

    const texts: BrandingManifest['texts'] = {
      [i18next.language]: {},
    }
    if (title != null) {
      texts[i18next.language]['title'] = title
    }

    return BrandingGuide.deserialize({
      colors:      colors,
      images:      images,
      texts:       texts,
      backgrounds: {},
      borders:     {},
      components:  {},
    })
  }
}

export interface BeWizrOrganizationTag {
  tag:                 string
  organizationalUnits: BeWizrOrganizationalUnit[]
}

export interface BeWizrOrganizationalUnit {
  id:    string
  title: string
}